import React, { useMemo } from "react";
import { useUsageLimits } from "@/hooks/pricing/useUsageLimits";
import { CoinsIcon, InfoIcon } from "lucide-react";
import { UsageText } from "@/components/Pricing/usage-text";
import { Tooltip } from "react-tooltip";
import { Separator } from "@/components/ui/separator";
import { useSession } from "@clerk/clerk-react";
interface Props {}

const TopUsageIndicator: React.FC<Props> = () => {
  const { remainingUsage } = useUsageLimits();
  const { session } = useSession();
  // Only render if there's a usage message and supabase is initialised
  if (!session) {
    return null;
  }

  const totalLeft = useMemo(() => {
    if (
      remainingUsage.subscriptionTier === "unlimited" ||
      remainingUsage.subscriptionTier === "new_unlimited"
    ) {
      return "Unlimited";
    }

    if (remainingUsage.usingPrompts) {
      const basePromptsLeft =
        remainingUsage.subscriptionTier === "free"
          ? Math.min(
              remainingUsage.dailyPromptsLeft || 0,
              remainingUsage.monthlyPromptsLeft || 0
            )
          : remainingUsage.monthlyPromptsLeft || 0;

      return basePromptsLeft + (remainingUsage.extraPromptsInPackages || 0);
    } else {
      return remainingUsage.tokensLeft || 0;
    }
  }, [remainingUsage]);

  return (
    <>
      <div
        className="flex justify-between items-center gap-1"
        data-tooltip-id="see-usage"
      >
        <CoinsIcon className="size-3 text-text-secondary" />
        <span className="text-xs text-text-secondary">{totalLeft}</span>
      </div>
      <Tooltip
        id="see-usage"
        className="opaque z-[200]"
        opacity={1}
        render={() => (
          <div className="flex flex-col gap-1 text-xs bg-background-secondary rounded-md pt-1.5">
            <UsageText />
          </div>
        )}
      />
    </>
  );
};

export default TopUsageIndicator;
